import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import RestCard from "../components/RestCard";
import Shimmer from "../components/Shimmer";
import { Search } from "lucide-react"
import { PROXY_SERVER, DELHI_LAT, DELHI_LNG } from "../utils/config";

export default function Restaurant(){

    const [searchParams] = useSearchParams();
    const [RestData, setRestData] = useState([])
    const [search, setSearch] = useState(searchParams.get("search") || "")
    const [error, setError] = useState(false)

    useEffect(()=>{

     async function fetchData() {
        try {
            const swiggyAPI = `https://www.swiggy.com/dapi/restaurants/list/v5?lat=${DELHI_LAT}&lng=${DELHI_LNG}&is-seo-homepage-enabled=true`;
            const response = await fetch(PROXY_SERVER+swiggyAPI);
            const data = await response.json();
            const restaurants = data?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants;
            if(Array.isArray(restaurants)){
                setRestData(restaurants);
            } else {
                setError(true);
            }
        } catch (err) {
            setError(true);
        }
     }

     fetchData();
    },[])

    if(error){
        return (
            <div className="w-[80%] mx-auto mt-20 text-center">
                <p className="text-xl text-charcoal/60">Couldn't load restaurants right now. Please try again shortly.</p>
            </div>
        )
    }

    if(RestData.length==0)
        return <Shimmer></Shimmer>

    const searchTerm = search.trim().toLowerCase();
    const filteredData = searchTerm
        ? RestData.filter((restInfo) => {
            const name = restInfo?.info?.name?.toLowerCase() || "";
            const cuisines = (restInfo?.info?.cuisines || []).join(" ").toLowerCase();
            return name.includes(searchTerm) || cuisines.includes(searchTerm);
          })
        : RestData;

    return (
        <div className="w-[80%] mx-auto mt-10 mb-20">

            <div className="flex items-center justify-between mb-6 flex-wrap gap-2">
                <h1 className="font-display text-3xl font-semibold text-charcoal">Restaurants near you</h1>
                <span className="text-charcoal/50 font-mono text-sm">{filteredData.length} found</span>
            </div>

            <div className="relative mb-8">
                <Search className="w-5 h-5 text-charcoal/40 absolute left-6 top-1/2 -translate-y-1/2" />
                <input
                    className="w-full py-4 pl-14 pr-6 text-xl bg-cream rounded-2xl border border-charcoal/15 shadow-sm outline-none transition focus:border-turmeric focus:ring-2 focus:ring-turmeric/50 placeholder:text-charcoal/40"
                    placeholder="Search restaurants or cuisines"
                    value={search}
                    onChange={(e)=>setSearch(e.target.value)}
                ></input>
            </div>

            {
                filteredData.length === 0
                    ? (
                        <div className="text-center py-20">
                            <p className="text-4xl mb-4">🔍</p>
                            <p className="text-xl text-charcoal/60">No restaurants found matching "{search}"</p>
                        </div>
                    )
                    : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                            {
                                filteredData.map((restInfo)=><RestCard key={restInfo?.info?.id} restInfo={restInfo}></RestCard>)
                            }
                        </div>
                    )
            }

        </div>
    )

}
